module.exports = __webpack_public_path__ + "static/media/darius.8f195b30.png";